// extracted by mini-css-extract-plugin
export default {"title_container":"Titles_title_container__MtC1X","subtitle":"Titles_subtitle__v-bnZ","title":"Titles_title__2-nmI","information":"Titles_information__iQ2MN"};